import { type FC } from 'react';
import { BrandedAuthPageLayoutComponent } from '~/authorization/pageWrapper/brandedAuthPageLayoutComponent';
import { RegisterFormContainer } from './form/registerForm.container';

export const RegisterPageComponent: FC = () => {
  return (
    <BrandedAuthPageLayoutComponent>
      <RegisterFormContainer />
    </BrandedAuthPageLayoutComponent>
  );
};
